import * as yup from "yup";
import BundleKey from "../../translation/bundleKey";

export const manualInputSchema = (translate: any) => {
  const schema = yup.object().shape({
    dni: yup.string().required(translate(BundleKey.ERROR_DNI_MUST)),
    //codeCountry: yup.string().required("Debe seleccionar un pais"),
  });
  return schema;
};
